import { createRouter, createWebHashHistory } from "vue-router";
import { queryUrl, isWeiXin } from "@/utils";
import store, {
  INIT_AUTH,
  CLEAR_FETCH_LIST,
  FETCH_LOADING,
  INIT_THEME,
} from "../store";
import { getUserInfo } from "@/utils/bridge";
import { wxWebAuthAsync } from "@/utils/wx";
import { puzeRoutes } from "./puzeRouter";
import sensors from "sa-sdk-javascript";
/**
 * meta.bridge 表示 页面是否从app取token等信息，外部分享的页面 要加上这个参数
 * theme 页面是否需要主题色，需要的话 会从app或者接口取
 * wxWebAuth 页面是否需要网页授权
 * **/
let initRoutes = [
  {
    path: "/404",
    name: "404",
    title: "404",
    meta: {
      title: "404",
      bridge: false,
      theme: false,
    },
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue"),
  },
  {
    path: "/about",
    name: "About",
    title: "关于我们",
    meta: {
      title: "关于我们",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/businessCard",
    name: "BusinessCard",
    title: "我的名片",
    meta: {
      title: "我的名片",
      theme: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "businessCard" */
        "../views/BusinessCard.vue"
      ),
  },
  {
    path: "/businessCardWxShare",
    name: "BusinessCardWxShare",
    title: "我的名片",
    meta: {
      title: "我的名片",
      bridge: false,
      wxWebAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "businessCardWxShare" */
        "../views/BusinessCardWxShare.vue"
      ),
  },
  {
    path: "/businessCardEditStyle",
    name: "BusinessCardEditStyle",
    title: "名片样式",
    meta: {
      title: "名片样式",
    },
    component: () =>
      import(
        /* webpackChunkName: "businessCardEditStyle" */
        "../views/BusinessCardEditStyle.vue"
      ),
  },
  {
    path: "/article",
    name: "Article",
    title: "文章详情",
    meta: {
      title: "文章详情",
    },
    component: () =>
      import(/* webpackChunkName: "article" */ "../views/Article.vue"),
  },
  {
    path: "/articleWxShare",
    name: "ArticleWxShare",
    title: "文章详情",
    meta: {
      title: "文章详情",
      bridge: false,
      wxWebAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "articleWxShare" */
        "../views/ArticleWxShare.vue"
      ),
  },
  {
    path: "/videoDetailsWxShare",
    name: "videoDetailsWxShare",
    title: "视频直播分享",
    meta: {
      title: "视频直播分享",
      bridge: false,
      wxWebAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "videoDetailsWxShare" */
        "../views/videoDetailsWxShare.vue"
      ),
  },
  {
    path: "/productDetails",
    name: "ProductDetails",
    title: "产品详情",
    meta: {
      title: "产品详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "productDetails" */
        "../views/ProductDetails.vue"
      ),
  },
  // 风险揭示， 项目亮点等新打开的产品详情
  {
    path: "/productExtend",
    name: "ProductExtend",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(
        /* webpackChunkName: "productExtend" */
        "../views/ProductExtend.vue"
      ),
  },
  // 产品资料详情,产品相关的资料、协议的详情页
  {
    path: "/fileDetails",
    name: "FileDetails",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(/* webpackChunkName: "fileDetails" */ "../views/FileDetails.vue"),
  },
  {
    path: "/revenueAllocation",
    name: "RevenueAllocation",
    title: "收益分配",
    meta: {
      title: "收益分配",
    },
    component: () =>
      import(
        /* webpackChunkName: "revenueAllocation" */
        "../views/RevenueAllocation.vue"
      ),
  },
  {
    path: "/orderDetails",
    name: "OrderDetails",
    title: "订单详情",
    meta: {
      title: "订单详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "orderDetails" */
        "../views/OrderDetails.vue"
      ),
  },
  //邀请注册
  {
    path: "/registerShare",
    name: "RegisterShare",
    title: "诚邀您加入",
    meta: {
      title: "诚邀您加入",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "registerShare" */
        "../views/RegisterShare.vue"
      ),
  },
  //邀请注册 投米
  {
    path: "/registerToumiShare",
    name: "RegisterToumiShare",
    title: "诚邀您加入",
    meta: {
      title: "诚邀您加入",
      bridge: false,
      wxWebAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "RegisterToumiShare" */
        "../views/RegisterToumiShare.vue"
      ),
  },
  //邀请注册（KASP）
  {
    path: "/registerKaspShare",
    name: "RegisterKaspShare",
    title: "诚邀您加入",
    meta: {
      title: "诚邀您加入",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "registerKaspShare" */
        "../views/RegisterKaspShare.vue"
      ),
  },
  //数字签名相关协议
  {
    path: "/protocol",
    name: "Protocol",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(/* webpackChunkName: "protocol" */ "../views/Protocol.vue"),
  },
  //《注册服务协议》《隐私政策》
  {
    path: "/otherInfo",
    name: "OtherInfo",
    title: "\u200E",
    meta: {
      title: "\u200E",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(/* webpackChunkName: "otherInfo" */ "../views/OtherInfo.vue"),
  },
  {
    path: "/activityDetails",
    name: "ActivityDetails",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(
        /* webpackChunkName: "activityDetails" */
        "../views/ActivityDetails.vue"
      ),
  },
  {
    path: "/activityDetailsWxShare",
    name: "ActivityDetailsWxShare",
    title: "\u200E",
    meta: {
      title: "\u200E",
      bridge: false,
      wxWebAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "activityDetailsWxShare" */
        "../views/ActivityDetailsWxShare.vue"
      ),
  },
  {
    path: "/loadingPage",
    name: "LoadingPage",
    title: "\u200E",
    meta: {
      title: "\u200E",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /*webpackChunkName: "loadingPage"*/
        "../views/LoadingPage.vue"
      ),
  },
  {
    path: "/insuranceDetail",
    name: "InsuranceDetail",
    title: "保险订单详情",
    meta: {
      title: "保险订单详情",
      theme: false,
    },
    component: () =>
      import(
        /*webpackChunkName: "insuranceDetail"*/
        "../views/InsuranceDetail.vue"
      ),
  },
  {
    path: "/insuranceRecordDetail",
    name: "InsuranceRecordDetail",
    title: "保险录单详情",
    meta: {
      title: "保险订单详情",
    },
    component: () =>
      import(
        /*webpackChunkName: "insuranceRecordDetail"*/
        "../views/InsuranceRecordDetail.vue"
      ),
  },
  {
    path: "/jumpModal",
    name: "JumpModal",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(
        /*webpackChunkName: "jumpModal"*/
        "../views/JumpModal.vue"
      ),
  },
  {
    path: "/insuranceList",
    name: "InsuranceList",
    title: "名阳保险",
    meta: {
      title: "名阳保险",
    },
    component: () =>
      import(
        /* webpackChunkName: "insuranceList" */
        "../views/InsuranceList.vue"
      ),
  },
  {
    path: "/insuranceOrder",
    name: "InsuranceOrder",
    title: "保险订单",
    meta: {
      title: "保险订单",
      // bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "insuranceOrder" */
        "../views/InsuranceOrder.vue"
      ),
  },
  {
    path: "/orderLoadingPage",
    name: "OrderLoadingPage",
    title: "\u200E",
    meta: {
      title: "\u200E",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /*webpackChunkName: "OrderLoadingPage"*/
        "../views/OrderLoadingPage.vue"
      ),
  },
  {
    path: "/recording",
    name: "Recording",
    title: "录单",
    meta: {
      title: "录单",
    },
    component: () =>
      import(/* webpackChunkName: "recording" */ "../views/Recording.vue"),
  },

  {
    path: "/channelpage",
    name: "Channelpage",
    title: "获客宝",
    meta: {
      title: "获客宝",
    },
    component: () =>
      import(/* webpackChunkName: "channelpage" */ "../views/Channelpage.vue"),
  },
  {
    path: "/partnerPage",
    name: "PartnerPage",
    title: "予能介绍",
    meta: {
      title: "予能介绍",
      bridge: false,
    },
    component: () =>
      import(/* webpackChunkName: "partnerPage" */ "../views/PartnerPage.vue"),
  },
  {
    path: "/VisitorDetails",
    name: "VisitorDetails",
    title: "访客详情",
    meta: {
      title: "访客详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "visitorDetails" */ "../views/VistorDetails/index.vue"
      ),
  },
  {
    path: "/shareDetails",
    name: "ShareDetails",
    title: "分享详情",
    meta: {
      title: "分享详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "shareDetails" */
        "../views/ShareDetails.vue"
      ),
  },
  {
    path: "/getDataBoard",
    name: "GetDataBoard",
    title: "获客数据看板",
    meta: {
      title: "获客数据看板",
    },
    component: () =>
      import(
        /* webpackChunkName: "getDataBoard" */
        "../views/GetDataBoard.vue"
      ),
  },
  {
    path: "/forwardPage",
    name: "ForwardPage",
    title: "转发记录",
    meta: {
      title: "转发记录",
    },
    component: () =>
      import(/* webpackChunkName: "forwardPage" */ "../views/ForwardPage.vue"),
  },
  {
    path: "/bookForward",
    name: "BookForward",
    title: "文章转发",
    meta: {
      title: "文章转发",
    },
    component: () =>
      import(/* webpackChunkName: "bookForward" */ "../views/BookForward.vue"),
  },
  {
    path: "/editArticle",
    name: "EditArticle",
    title: "文章详情",
    meta: {
      title: "文章详情",
    },
    component: () =>
      import(/* webpackChunkName: "editArticle" */ "../views/EditArticle.vue"),
  },
  // 盈米页面跳转中间页面
  {
    path: "/redirect",
    name: "redirect",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(
        /* webpackChunkName: "redirect" */ "../views/microPage/redirect.vue"
      ),
  },
  {
    path: "/microPage",
    name: "MicroPage",
    title: "微页面",
    meta: {
      title: "\u200E",
      bridge: false,
      wxWebAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "visitorDetails" */ "../views/microPage/index.vue"
      ),
  },
  //微页面 文章列表
  {
    path: "/activityModal",
    name: "ActivityModal",
    title: "精选文章",
    meta: {
      title: "精选文章",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "activityModal" */ "../views/ActivityModal.vue"
      ),
  },
  //微页面 文章详情
  {
    path: "/onlyReadyActivity",
    name: "OnlyReadyActivity",
    title: "精选文章",
    meta: {
      title: "精选文章",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "onlyReadyActivity" */ "../views/OnlyReadyActivity.vue"
      ),
  },
  //微页面 海报详情
  {
    path: "/posterDetails",
    name: "PosterDetails",
    title: "海报详情",
    meta: {
      title: "海报详情",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "posterDetails" */ "../views/PosterDetails.vue"
      ),
  },
  {
    path: "/SDKPage",
    name: "SDKPage",
    title: "第三方SDK列表",
    meta: {
      title: "第三方SDK列表",
      bridge: false,
    },
    component: () =>
      import(/* webpackChunkName: "SDKPage" */ "../views/SDKPage.vue"),
  },
  {
    path: "/infoCollect",
    name: "InfoCollect",
    title: "个人信息收集清单",
    meta: {
      title: "个人信息收集清单",
      bridge: false,
    },
    component: () =>
      import(/* webpackChunkName: "infoCollect" */ "../views/infoCollect.vue"),
  },
  {
    path: "/extraAgreement",
    name: "ExtraAgreement",
    title: "理财师合作协议",
    meta: {
      title: "理财师合作协议",
      bridge: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "extraAgreement" */ "../views/ExtraAgreement.vue"
      ),
  },
  {
    path: "/permissionApply",
    name: "PermissionApply",
    title: "权限申请与使用情况说明",
    meta: {
      title: "权限申请与使用情况说明",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "permissionApply" */ "../views/permissionApply.vue"
      ),
  },
  {
    path: "/auctionArea",
    name: "AuctionArea",
    title: "拍卖专区",
    meta: {
      title: "拍卖专区",
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionArea" */ "../views/auction/AuctionArea.vue"
      ),
  },
  //拍卖产品列表
  {
    path: "/monthDate",
    name: "MonthDate",
    title: "\u200E",
    meta: {
      title: "\u200E",
      // bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "monthDate" */ "../views/auction/MonthDate.vue"
      ),
  },
  //拍卖产品详情页面
  {
    path: "/auctionDetails",
    name: "AuctionDetails",
    title: "",
    meta: {
      title: "",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionDetails" */ "../views/auction/AuctionDetails.vue"
      ),
  },
  {
    path: "/auctionAnnouncer",
    name: "AuctionAnnouncer",
    title: "挂牌公告方",
    meta: {
      title: "挂牌公告方",
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionAnnouncer" */ "../views/auction/AuctionAnnouncer.vue"
      ),
  },
  {
    path: "/auctionPromoter",
    name: "AuctionPromoter",
    title: "产品推介方",
    meta: {
      title: "产品推介方",
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionPromoter" */ "../views/auction/AuctionPromoter.vue"
      ),
  },
  // 转让方
  {
    path: "/auctionTransferor",
    name: "AuctionTransferor",
    title: "转让方",
    meta: {
      title: "转让方",
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionTransferor" */ "../views/auction/AuctionTransferor.vue"
      ),
  },
  // 拍卖的销售数据
  {
    path: "/auctionSalesData",
    name: "AuctionSalesData",
    title: "拍卖",
    meta: {
      title: "拍卖",
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionSalesData" */ "../views/auction/AuctionSalesData.vue"
      ),
  },
  // 待付款订单
  {
    path: "/pendingPayment",
    name: "PendingPayment",
    title: "待付款订单",
    meta: {
      title: "待付款订单",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "pendingPayment" */ "../views/PendingPayment.vue"
      ),
  },
  // 拍卖订单详情
  {
    path: "/auctionOrderDetails",
    name: "AuctionOrderDetails",
    title: "数据详情",
    meta: {
      title: "数据详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "auctionOrderDetails" */ "../views/auction/AuctionOrderDetails.vue"
      ),
  },
  // 慧择保险授权页面
  {
    path: "/insuranceAuth",
    name: "InsuranceAuth",
    title: "",
    meta: {
      title: "",
    },
    component: () =>
      import(
        /* webpackChunkName: "insuranceAuth" */ "../views/InsuranceAuth.vue"
      ),
  },
  // 微信授权的页面（跳转中间页）
  {
    path: "/wxAuth",
    name: "WxAuth",
    title: "",
    meta: {
      title: "",
      bridge: false,
    },
    component: () =>
      import(/* webpackChunkName: "wxAuth" */ "../views/WxAuth.vue"),
  },
  // 微信授权
  {
    path: "/wxError",
    name: "WxError",
    title: "",
    meta: {
      title: "",
      bridge: false,
    },
    component: () =>
      import(/* webpackChunkName: "wxError" */ "../views/WxError.vue"),
  },
  // 方德（日日盈）授权页面
  {
    path: "/fangdeAuth",
    name: "FangdeAuth",
    title: "授权",
    meta: {
      title: "授权",
    },
    component: () =>
      import(/* webpackChunkName: "fangdeAuth" */ "../views/FangdeAuth.vue"),
  },
  // 协议详情
  {
    path: "/agreementDetails",
    name: "AgreementDetails",
    title: "",
    meta: {
      title: "",
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "agreementDetails" */ "../views/AgreementDetails.vue"
      ),
  },
  // 二维码引导页
  {
    path: "/guideTopuze",
    name: "GuideTopuze",
    title: "下载普泽基金App",
    meta: {
      title: "下载普泽基金App",
      // bridge: false,
      theme: false,
    },
    component: () =>
      import(/* webpackChunkName: "GuideTopuze" */ "../views/GuideToPuze.vue"),
  },
  // 二维码弹窗
  {
    path: "/guideToPuzeModal",
    name: "GuideToPuzeModal",
    title: "",
    meta: {
      title: "",
      // bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "GuideToPuzeModal" */ "../views/GuideToPuzeModal.vue"
      ),
  },
  // 瑞承导流
  {
    path: "/puzeIntro",
    name: "puzeIntro",
    title: "",
    meta: {
      title: "瑞承国际",
      // bridge: false,
      theme: false,
    },
    component: () =>
      import(/* webpackChunkName: "puzeIntro" */ "../views/puzeIntro.vue"),
  },
  //直播介绍弹窗
  {
    path: "/liveIntroduce",
    name: "LiveIntroduce",
    title: "",
    meta: {
      title: "",
      // bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "LiveIntroduce" */ "../views/LiveIntroduce.vue"
      ),
  },
  //投米下载页
  {
    path: "/downToumi",
    name: "downToumi",
    title: "下载投米",
    meta: {
      title: "下载投米",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(/* webpackChunkName: "downToumi" */ "../views/downToumi.vue"),
  },
  //投米下载页, 短信中打开，唤醒下载连接
  {
    path: "/downToumiApp",
    name: "downToumiApp",
    title: "下载投米",
    meta: {
      title: "下载投米",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "downToumiApp" */ "../views/downToumiApp.vue"
      ),
  },
  //予能下载页
  {
    path: "/downYuneng",
    name: "downYuneng",
    title: "下载予能",
    meta: {
      title: "下载予能",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(/* webpackChunkName: "downYuneng" */ "../views/downYuneng.vue"),
  },
  //予能下载页, 短信中打开，唤醒下载连接
  {
    path: "/downYunengApp",
    name: "downYunengApp",
    title: "下载予能",
    meta: {
      title: "下载予能",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "downYunengApp" */ "../views/downYunengApp.vue"
      ),
  },
  // 理财师注册邀请页面
  {
    path: "/registerInvitation",
    name: "RegisterInvitation",
    title: "理财师邀请计划",
    meta: {
      title: "理财师邀请计划",
    },
    component: () =>
      import(
        /* webpackChunkName: "registerInvitation" */ "../views/RegisterInvitation.vue"
      ),
  },
  // 邀理财师注册页面
  {
    path: "/registerPlannerShare",
    name: "RegisterPlannerShare",
    title: "诚邀您加入理财师团队",
    meta: {
      title: "诚邀您加入理财师团队",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "registerPlannerShare" */ "../views/RegisterPlannerShare.vue"
      ),
  },
  // 银行限额表
  {
    path: "/supportingBank",
    name: "supportingBank",
    title: "支持银行及限额",
    meta: {
      title: "支持银行及限额",
      bridge: true,
    },
    component: () => import("../views/SupportingBank.vue"),
  },
  //搜索页
  {
    path: "/search",
    name: "Search",
    title: "基金搜索",
    meta: {
      title: "基金搜索",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(/* webpackChunkName: "search" */ "../views/Search/index.vue"),
  },
  //其他资产
  {
    path: "/otherAssets",
    name: "OtherAssets",
    title: "其他资产",
    meta: {
      title: "其他资产",
      bridge: false,
    },
    component: () =>
      import(/* webpackChunkName: "OtherAssets" */ "../views/OtherAssets.vue"),
  },
  //其他资产
  {
    path: "/yingmiloadPage",
    name: "yingmiloadPage",
    title: "其他资产",
    meta: {
      title: "其他资产",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "yingmiloadPage" */ "../views/yingmiloadPage.vue"
      ),
  },
  //嘉系列订单列表
  {
    path: "/jiaList",
    name: "jiaList",
    title: "嘉系列",
    meta: {
      title: "嘉系列",
      bridge: true,
    },
    component: () => import("../views/JiaList.vue"),
  },
  //嘉系列订单详情
  {
    path: "/jiaOrderDetail",
    name: "jiaOrderDetail",
    title: "订单详情",
    meta: {
      title: "订单详情",
      bridge: true,
    },
    component: () => import("../views/JiaOrderDetails.vue"),
  },
  //结算规则
  {
    path: "/settlementRules",
    name: "SettlementRules",
    title: "结算规则",
    meta: {
      title: "结算规则",
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "settlementRules" */ "../views/SettlementRules.vue"
      ),
  },
  // 线下金融产品的列表
  {
    path: "/offlineFinancialProducts",
    name: "OfflineFinancialProducts",
    title: "产品列表",
    meta: {
      title: "产品列表",
    },
    component: () =>
      import(
        /* webpackChunkName: "offlineFinancialProducts" */ "../views/OfflineFinancialProducts.vue"
      ),
  },
  // 线下金融产品的详情页面
  {
    path: "/offlineFinancialProductDetails",
    name: "OfflineFinancialProductDetails",
    title: "产品详情",
    meta: {
      title: "产品详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "offlineFinancialProductDetails" */ "../views/OfflineFinancialProductDetails.vue"
      ),
  },
  // 线下非金融产品的列表
  {
    path: "/offlineNonFinancialProducts",
    name: "OfflineNonFinancialProducts",
    title: "产品列表",
    meta: {
      title: "产品列表",
    },
    component: () =>
      import(
        /* webpackChunkName: "offlineNonFinancialProducts" */ "../views/OfflineNonFinancialProducts.vue"
      ),
  },
  // 线下非金融产品的详情页面
  {
    path: "/offlineNonFinancialProductDetails",
    name: "OfflineNonFinancialProductDetails",
    title: "产品详情",
    meta: {
      title: "产品详情",
    },
    component: () =>
      import(
        /* webpackChunkName: "offlineNonFinancialProductDetails" */ "../views/OfflineNonFinancialProductDetails.vue"
      ),
  },
  // 产品系数表-私募股权/资管计划
  {
    path: "/productRatios",
    name: "ProductRatios",
    title: "产品系数表",
    meta: {
      title: "产品系数表",
      bridge: false,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "productRatios" */ "../views/ProductRatios.vue"
      ),
  },
  // 盈米授权页面
  {
    path: "/yingmiAuth",
    name: "YingmiAuth",
    title: "\u200E",
    meta: {
      title: "\u200E",
    },
    component: () =>
      import(/* webpackChunkName: "yingmiAuth" */ "../views/YingmiAuth.vue"),
  },
  // 海外生活订单列表
  {
    path: "/overseasOrderList",
    name: "OverseasOrderList",
    title: "海外生活",
    meta: {
      title: "海外生活",
      bridge: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "overseasOrderList" */ "../views/OverseasOrderList.vue"
      ),
  },
  // 海外生活订单详情
  {
    path: "/overseasOrderDetail",
    name: "overseasOrderDetail",
    title: "订单详情",
    meta: {
      title: "订单详情",
      bridge: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "overseasOrderList" */ "../views/OverseasOrderDetail.vue"
      ),
  },
  // 客户标签说明
  {
    name: "CustomerLabelDes",
    path: "/customerLabelDes",
    title: "标签说明",
    meta: {
      title: "标签说明",
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "customerLabelDes" */ "../views/CustomerLabelDes.vue"
      ),
  },
  // 视频观看历史
  {
    name: "VideoViewHistory",
    path: "/videoViewHistory",
    title: "学习记录",
    meta: {
      title: "学习记录",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "videoViewHistory" */ "../views/VideoViewHistory.vue"
      ),
  },
  {
    name: "test",
    path: "/test",
    title: "测试",
    meta: {
      title: "test",
      bridge: false,
      theme: false,
    },
    component: () => import(/* webpackChunkName: "test" */ "../views/test.vue"),
  },
  {
    name: "AiPosterHome",
    path: "/ai-poster/home",
    title: "海报定制",
    meta: {
      title: "海报定制",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "AiPosterHome" */ "../views/ai-poster/home.vue"
      ),
  },
  {
    name: "AiPosterEdit",
    path: "/ai-poster/edit",
    title: "海报编辑",
    meta: {
      title: "海报编辑",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "AiPosterEdit" */ "../views/ai-poster/poster-edit.vue"
      ),
  },
  {
    name: "AiPosterDetail",
    path: "/ai-poster/detail",
    title: "海报详情",
    meta: {
      title: "海报详情",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "AiPosterEdit" */ "../views/ai-poster/poster-detail.vue"
      ),
  },
  {
    name: "AiPosterView",
    path: "/ai-poster/view",
    title: "海报查看",
    meta: {
      title: "海报查看",
      bridge: true,
      theme: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "AiPosterEdit" */ "../views/ai-poster/poster-view.vue"
      ),
  },

  {
    path: "/hexiangLoading",
    name: "hexiangLoading",
    title: "加载中",
    meta: {
      title: "加载中",
      theme: false,
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "loading" */ "../views/hexiangProductList/Loading.vue"
      ),
  },
  {
    path: "/hexiangProductList",
    name: "hexiangProductList",
    title: "保险列表",
    meta: {
      title: "保险列表",
    },
    component: () =>
      import(
        /* webpackChunkName: "productList" */ "../views/hexiangProductList/index.vue"
      ),
  },
  {
    path: "/hexiangDetail",
    name: "hexiangDetail",
    title: "保险详情",
    meta: {
      title: "保险详情",
      theme: false,
      bridge: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "hexiangDetail" */ "../views/hexiangProductList/detail.vue"
      ),
  },
  // 用户列表
  {
    path: "/allUserList",
    name: "AllUserList",
    title: "用户列表",
    meta: {
      title: "用户列表",
    },
    component: () =>
      import(/* webpackChunkName: "AllUserList" */ "../views/AllUserList.vue"),
  },
  {
    path: "/myPoints",
    name: "myPoints",
    title: "我的积分",
    meta: {
      title: "我的积分",
    },
    component: () =>
      import(/* webpackChunkName: "myPoints" */ "../views/myPoints.vue"),
  },
];
const routes = [...initRoutes, ...puzeRoutes];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const { name, meta } = to;
  let { bridge, title } = meta;
  document.title = title;

  if (!name) {
    return next("/404");
  }
  // 进入页面之前初始化 token,tenantId, authorization
  // code,releaseType 为微页面的字段
  let {
    token,
    tenantId,
    outId,
    authorization,
    wxWebAuth,
    code,
    releaseType,
    channel,
    miniH5NeedToken,
    inApp,
    appId, // app里会给添加的标识
  } = queryUrl(location.href);
  token = token || store.state.token;
  authorization = authorization || store.state.authorization;
  tenantId = tenantId || store.state.tenantId;
  outId = outId || store.state.outId;
  // 主题色
  let theme = store.state.theme;
  // dev启动环境的特殊处理bridge，本地开发bridge默认false
  if (process.env.VUE_APP_ENV || (name === "MicroPage" && !appId)) {
    bridge = false;
  }
  // 盈米需求需要app token,通过特殊字段处理
  if (miniH5NeedToken) {
    bridge = true;
  }

  if (
    (!token || !authorization || !tenantId) &&
    bridge !== false &&
    inApp !== "0" &&
    !isWeiXin
  ) {
    try {
      const userInfo = await getUserInfo();
      token = userInfo.token;
      authorization = userInfo.authorization;
      tenantId = userInfo.tenantId;
      outId = userInfo.outId;
      theme = userInfo.theme;
    } catch (e) {
      console.log(e);
    }
  }
  store.commit({
    type: INIT_AUTH,
    token,
    authorization,
    tenantId,
    outId,
  });
  if (outId) {
    sensors.login(outId);
  }

  // 初始化主题
  if (theme) {
    initTheme(theme);
    store.commit({
      type: INIT_THEME,
      theme,
    });
  }
  if (
    meta.theme !== false &&
    !document.getElementById("flagshipTheme") &&
    !theme
  ) {
    try {
      let themeInfo;
      if (name === "MicroPage" || name === "puze-micropage") {
        themeInfo = await store.dispatch("getMicroTheme", {
          code,
          releaseType,
          channel,
        });
      } else {
        themeInfo = await store.dispatch("getTheme", {
          appSource: 1,
          tenantId,
        });
      }

      if (themeInfo && themeInfo.mainColor) {
        initTheme(themeInfo);
        store.commit({
          type: INIT_THEME,
          theme: themeInfo,
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
  store.commit({
    type: CLEAR_FETCH_LIST,
  });
  store.commit({
    type: FETCH_LOADING,
    fetchLoading: false,
  });
  if (
    !store.state.wxInfo &&
    meta.wxWebAuth &&
    (!wxWebAuth || (wxWebAuth && wxWebAuth !== "0"))
  ) {
    const flag = await wxWebAuthAsync(next);
    if (!flag) {
      return;
    }
  }
  next();
});
// 初始化主题方法
function initTheme(themeObj) {
  const head = document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.setAttribute("id", "flagshipTheme");
  style.setAttribute("type", "text/css");
  style.innerHTML = `:root{--primary: ${themeObj.mainColor};
  --primaryGradient: linear-gradient(90deg,  ${themeObj.mainGradientColorBeg} 0%,  ${themeObj.mainGradientColorEnd} 100%);
  --sub: ${themeObj.subColor};
  --subGradient: linear-gradient(90deg, ${themeObj.subGradientColorBeg} 0%, ${themeObj.subGradientColorEnd} 100%);}`;
  head.append(style);
}
export default router;
